import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconLanguageSvg } from "./IconLanguageSvg.mjs";
const IconLanguage = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconLanguageSvg, ...svgProps }) });
export {
  IconLanguage
};
